export default {
  email(value, errorMessage = 'Indtast venligst en gyldig e-mailadresse') {
    const regex = /^[\w\.\-\+]*@[\.\-\w]*[\.\w{2,}]+$/
    if (!value || value.length === 0 || value.match(regex) == null) {
      return errorMessage
    }
    return true
  },

  countryCode(value, errorMessage = 'Landekoden skal være på minimum to tal') {
    const regex = /^(\+?\d{1,3}|\d{1,4})$/
    if (!value || value.length === 0 || value.match(regex) == null) {
      return errorMessage
    }
    return true
  },

  phone(value, errorMessage = 'Telefonnummeret skal være på minimum 8 tal') {
    const regex = /(?:[\d\.]\s*){8,15}$/
    if (!value || value.length === 0 || value.match(regex) == null) {
      return errorMessage
    }
    return true
  },

  birthDate(value, errorMessage = 'Datoformatet skal være DD/MM/YYYY') {
    const regex = /^((19\d{2})|(20\d{2}))-(((02)-(0[1-9]|[1-2][0-9]))|(((0(1|[3-9]))|(1[0-2]))-(0[1-9]|[1-2][0-9]|30))|((01|03|05|07|08|10|12)-(31)))$/
    if (!value || value.length === 0 || value.match(regex) == null) {
      return errorMessage
    }
    return true
  },

  password(value, errorMessage = 'Kodeordet opfylder ikke kravene. Det skal være minimum 8 karakterer langt og indeholde mindst et lille bogstav, et stort bogstav, et tal og et special tegn.') {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\(\)\[\]\/\-_\\=!@#$%^&*;,:.<>+]).{8,}$/
    if (!value || value.length === 0 || value.match(regex) == null) {
      return errorMessage
    }
    return true
  },

  cprNumber(value, errorMessage = 'Indtast venligst et gyldigt cpr-nummer') {
    const regex = /^\d{6}-?\d{4}$/
    if (!value || value.length === 0 || value.match(regex) == null) {
      return errorMessage
    }
    return true
  },
}
